import styled from 'styled-components'

export const Container = styled.span`
  display: flex;
  color: ${props => props.theme.colors.color122d52};
  font-family: 'Inter';
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.05rem;
`
